// 개발자에게 문의하기 플로팅 버튼 컴포넌트
import React, { useState } from 'react';
import { Fab, Tooltip } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { useTranslation } from 'react-i18next';
import ContactDeveloperDialog from './ContactDeveloperDialog';

function ContactDeveloperFab() {
  const { t } = useTranslation('common');
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Tooltip title={t('contact.fabTooltip')} placement="left">
        <Fab
          color="primary"
          aria-label={t('contact.fabTooltip')}
          onClick={() => setDialogOpen(true)}
          sx={{
            position: 'fixed',
            bottom: { xs: 80, sm: 90 }, // 광고 배너 위
            right: { xs: 16, sm: 24 },
            zIndex: 1000,
          }}
        >
          <ContactSupportIcon />
        </Fab>
      </Tooltip>

      <ContactDeveloperDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
}

export default ContactDeveloperFab;
